import { acceptHMRUpdate, defineStore } from "pinia";
import { computed, reactive, toRefs } from "vue";
import { useI18n } from "vue-i18n";
import { useToast } from "vue-toastification";

import type { LeArticleFeedbackModalProps } from "@/types/components/le-article-feedback-modal.type";

import { useGlobalModalsStore } from ".";

const STORE_ID = "articleFeedbackModal";

type State = Partial<LeArticleFeedbackModalProps>;

export const useArticleFeedbackModalStore = defineStore(STORE_ID, () => {
  const state = reactive<State>({
    article: undefined,
    dictionary: undefined,
    methodId: undefined
  });

  const { t } = useI18n();
  const globalModalsStore = useGlobalModalsStore();

  const isFeedbackModalOpen = computed<boolean>(() => globalModalsStore.articleFeedback.isOpen);

  const openFeedbackModal = (
    article: LeArticleFeedbackModalProps["article"],
    dictionary: LeArticleFeedbackModalProps["dictionary"],
    methodId: LeArticleFeedbackModalProps["methodId"]
  ): void => {
    Object.assign(state, { article, dictionary, methodId });

    globalModalsStore.articleFeedback.isOpen = true;
  };

  const closeFeedbackModal = (didSubmit: boolean): void => {
    globalModalsStore.closeModal("articleFeedback");

    Object.assign(state, {});

    if (didSubmit) {
      const toast = useToast();
      toast.clear();
      toast(t("le-feedback-button.toast"));
    }
  };

  return {
    ...toRefs(state),
    isFeedbackModalOpen,

    openFeedbackModal,
    closeFeedbackModal
  };
});

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useArticleFeedbackModalStore, import.meta.hot));
}
